import { PASSWORD_RESET } from '../../constants/action-types/passwordReset';

const INITIAL_STATE = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  error: null,
};

const passwordResetReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PASSWORD_RESET.START:
      return { ...state, isLoading: true, isSuccess: false, isError: false, error: null };
    case PASSWORD_RESET.SUCCESS:
      return { ...state, isLoading: false, isSuccess: true, isError: false };
    case PASSWORD_RESET.ERROR:
      return { ...state, isLoading: false, isSuccess: false, isError: true, error: action.payload.error };
    default:
      return state;
  }
};

export default passwordResetReducer;
